import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {RobotManagementFeature} from "../../features/robotManagement";

const ALLOWED_PERMISSION = 'robotManagement'

const RobotManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <RobotManagementFeature
      userToken={userToken}
    />
  </PermissionGuard>
)

export default RobotManagementPage
